var __jsx = React.createElement;
import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import styles from '../../styles/compare/OfferDetails.module.scss';
import { getDepositInterestType } from '../../utils/compare/CompareUtilities';
import * as gtag from '../../cookie/lib/gtag';

var CreditCardDetails = function CreditCardDetails(props) {
  var show = props.show,
      handleClose = props.handleClose,
      details = props.details,
      applyParams = props.applyParams,
      product = props.product;
  var provider = details.showLogo ? __jsx(Image, {
    src: details.providerLogo,
    height: details.logoSize.height,
    width: details.logoSize.width
  }) : __jsx("p", null, details.bank);
  var relOpennerTag;

  if (details.hasOwnProperty('apply')) {
    relOpennerTag = details.apply.indexOf(" ".concat(process.env.NEXT_PUBLIC_SITE_URL, " ")) > -1 ? '' : 'noopener';
  } else {
    relOpennerTag = '';
  }

  var onApply = function onApply() {
    if (window.location.hostname.indexOf('conso.ro') > 1) {
      gtag.event('Apply', {
        provider: details.provider,
        product: product
      });
    } else {
      console.log("beta");
    }

    handleClose();
  };

  return __jsx(Modal, {
    show: show,
    onHide: handleClose,
    dialogClassName: styles.modal90w
  }, __jsx(Modal.Header, {
    closeButton: true
  }, __jsx(Modal.Title, null, provider, __jsx("p", {
    className: "".concat(styles.productName, " text-muted mb-0")
  }, details.product))), __jsx(Modal.Body, null, details.hasOwnProperty('apply') && __jsx(Link, {
    href: details.apply.indexOf("".concat(process.env.NEXT_PUBLIC_SITE_URL)) > -1 ? "".concat(details.apply).concat(applyParams.length > 0 ? '?' + applyParams : '') : details.apply
  }, __jsx("a", {
    onClick: onApply,
    rel: relOpennerTag,
    target: details.apply.indexOf("".concat(process.env.NEXT_PUBLIC_SITE_URL)) > -1 ? '_self' : '_blank',
    title: "Solicit\u0103 oferta",
    className: "btn btn-primary mt-2 mb-3"
  }, "Solicit\u0103 oferta", __jsx(FontAwesomeIcon, {
    className: "ml-2",
    icon: faChevronRight,
    height: "16",
    width: "16"
  }))), __jsx(Row, {
    className: styles.endSection
  }, __jsx(Col, {
    xs: "12",
    className: styles.productSection
  }, "Cost total"), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "DAE cump\u0103r\u0103turi"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, Intl.NumberFormat('fr', {
    maximumFractionDigits: 2
  }).format(details.purchaseApr), "%"), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "DAE numerar"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, Intl.NumberFormat('fr', {
    maximumFractionDigits: 2
  }).format(details.cashApr), "%")), __jsx(Row, {
    className: styles.endSection
  }, __jsx(Col, {
    xs: "12",
    className: styles.productSection
  }, "Rata dob\xE2nzii"), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Pentru cump\u0103r\u0103turi"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, Intl.NumberFormat('fr', {
    maximumFractionDigits: 2
  }).format(details.purchaseInterestRate), "%, ", getDepositInterestType(details.rateType), details.rateType == 'variable' && __jsx(React.Fragment, null, " (", Intl.NumberFormat('fr', {
    maximumFractionDigits: 2
  }).format(details.purchaseInterestMargin), "% + IRCC)")), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Pentru retragere numerar"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, Intl.NumberFormat('fr', {
    maximumFractionDigits: 2
  }).format(details.cashInterestRate), "%, ", getDepositInterestType(details.rateType), details.rateType == 'variable' && __jsx(React.Fragment, null, " (", Intl.NumberFormat('fr', {
    maximumFractionDigits: 2
  }).format(details.cashInterestMargin), "% + IRCC)"))), __jsx(Row, {
    className: styles.endSection
  }, __jsx(Col, {
    xs: "12",
    className: styles.productSection
  }, "Comisioane"), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Taxa de emitere"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, details.issuingFee), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Taxa administrare"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, details.managementFee)), __jsx(Row, {
    className: styles.endSection
  }, __jsx(Col, {
    xs: "12",
    className: styles.productSection
  }, "Costuri la tranzac\u021Bii"), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Pl\u0103\u021Bi la comercian\u021Bi"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, details.purchaseFeeNational), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Pl\u0103\u021Bi \xEEn str\u0103in\u0103tate"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, details.purchaseFeeForeign), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Retragere numerar - ATM banc\u0103"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, details.cashWithdrawalBankATM), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Retragere numerar - ATM din \u021Bar\u0103"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, details.cashWithdrawalNationalATM), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Retragere numerar - ATM din str\u0103in\u0103tate"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, details.cashWithdrawalForeignATM)), __jsx(Row, {
    className: styles.endSection
  }, __jsx(Col, {
    xs: "12",
    className: styles.productSection
  }, "Rambursare credit"), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Perioada de gra\u021Bie"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, "p\xE2n\u0103 la ", details.graceMaxPeriod, " zile"), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Tranzac\u021Bii cu perioad\u0103 de gra\u021Bie"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, details.gracePeriodTransaction), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Suma minim\u0103 de plat\u0103"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, details.minimumPayment)), details.category.includes('cashback') && __jsx(Row, {
    className: styles.endSection
  }, __jsx(Col, {
    xs: "12",
    className: styles.productSection
  }, "Program cashback"), __jsx(Col, {
    xs: "12",
    className: styles.info,
    dangerouslySetInnerHTML: {
      __html: details.cashbackInfo
    }
  })), details.category.includes('rewards') && __jsx(Row, {
    className: styles.endSection
  }, __jsx(Col, {
    xs: "12",
    className: styles.productSection
  }, "Program Puncte Bonus"), __jsx(Col, {
    xs: "12",
    className: styles.info,
    dangerouslySetInnerHTML: {
      __html: details.rewardsInfo
    }
  })), details.category.includes('freeInterest') && __jsx(Row, {
    className: styles.endSection
  }, __jsx(Col, {
    xs: "12",
    className: styles.productSection
  }, "Program Rate cu 0% dob\xE2nd\u0103"), __jsx(Col, {
    xs: "12",
    className: styles.info,
    dangerouslySetInnerHTML: {
      __html: details.freeInterestInfo
    }
  })), details.otherBenefitsInfo && __jsx(Row, {
    className: styles.endSection
  }, __jsx(Col, {
    xs: "12",
    className: styles.productSection
  }, "Diverse beneficii"), __jsx(Col, {
    xs: "12",
    className: styles.info,
    dangerouslySetInnerHTML: {
      __html: details.otherBenefitsInfo
    }
  })), details.category.includes('balanceTransfer') && __jsx(Row, {
    className: styles.endSection
  }, __jsx(Col, {
    xs: "12",
    className: styles.productSection
  }, "Condi\u021Bii de refinan\u021Bare"), __jsx(Col, {
    xs: "12",
    className: styles.info,
    dangerouslySetInnerHTML: {
      __html: details.balanceTransferInfo
    }
  }))), __jsx(Modal.Footer, {
    className: "justify-content-between"
  }, details.hasOwnProperty('apply') && __jsx(Link, {
    href: details.apply.indexOf("".concat(process.env.NEXT_PUBLIC_SITE_URL)) > -1 ? "".concat(details.apply).concat(applyParams.length > 0 ? '?' + applyParams : '') : details.apply
  }, __jsx("a", {
    onClick: onApply,
    rel: relOpennerTag,
    target: details.apply.indexOf("".concat(process.env.NEXT_PUBLIC_SITE_URL)) > -1 ? '_self' : '_blank',
    title: "Solicit\u0103 oferta",
    className: "btn btn-primary mt-2 mb-3"
  }, "Solicit\u0103 oferta", __jsx(FontAwesomeIcon, {
    className: "ml-2",
    icon: faChevronRight,
    height: "16",
    width: "16"
  }))), __jsx(Button, {
    variant: "outline-secondary",
    onClick: handleClose
  }, "\xCEnchide")));
};

export default CreditCardDetails;